<div class="container-fluid p-0 m-0 mt-1">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div *ngIf="summary && objectKeys(summary).length > 0">
          <div class="card-header">
            <h6 class="mt-2">{{ "STATISTICS.TITLE" | translate }}</h6>
          </div>
          <div class="card-body pb-0">
            <div class="row">
              <div class="col-12">
                <div class="table-container mb-3">
                  <div class="table-responsive table-scrollable">
                    <table
                      class="table table-bordered table-hover table-sticky-header"
                    >
                      <thead>
                        <tr>
                          <th>{{ "STATISTICS.APPLICATIONS" | translate }}</th>
                          <th>{{ "STATISTICS.STORAGE_SIZE" | translate }}</th>
                          <th>{{ "STATISTICS.TOTAL_RECORDS" | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let row of summary | keyvalue">
                          <tr
                            *ngIf="row.key === 'Total'"
                            [ngClass]="'dark-gray-bg total-bgcolor'"
                          >
                            <td>{{ row.key | translate }}</td>
                            <td>
                              {{ formatStorageSize(row.value.storageSize) }}
                            </td>
                            <td>{{ row.value.count }}</td>
                          </tr>
                        </ng-container>

                        <ng-container *ngFor="let row of summary | keyvalue">
                          <tr *ngIf="row.key !== 'Total'">
                            <td>
                              <button
                                class="btn btn-link p-0"
                                (click)="
                                  row.value.showDetails = !row.value.showDetails
                                "
                              >
                                <span
                                  [class]="
                                    row.value.showDetails
                                      ? 'bi bi-caret-down-fill'
                                      : 'bi bi-caret-right-fill'
                                  "
                                ></span>
                                {{ row.key | translate }}
                              </button>
                            </td>
                            <td>
                              {{ formatStorageSize(row.value.storageSize) }}
                            </td>
                            <td>{{ row.value.count }}</td>
                          </tr>

                          <ng-container *ngIf="row.value.showDetails">
                            <ng-container
                              *ngFor="
                                let table of appStorageInfoList?.[row.key]
                                  | keyvalue
                              "
                            >
                              <tr>
                                <td class="ps-5">
                                  {{ row.key | translate }}
                                  {{ "STATISTICS.FILE_SIZE" | translate }}
                                </td>
                                <td>
                                  {{ formatStorageSize(table.value.totalSize) }}
                                </td>
                                <td>{{ table.value.count }}</td>
                              </tr>
                            </ng-container>

                            <ng-container
                              *ngFor="
                                let table of appInfoList?.[row.key] | keyvalue
                              "
                            >
                              <tr>
                                <td class="ps-5">
                                  {{ table.key | translate }}
                                </td>
                                <td>
                                  {{
                                    formatStorageSize(table.value.storageSize)
                                  }}
                                </td>
                                <td>{{ table.value.count }}</td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6 col-12 mb-2">
                <div class="card p-2">
                  <div class="chart-container">
                    <canvas id="summary-chart-size"></canvas>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-12 mb-2">
                <div class="card p-2">
                  <div class="chart-container">
                    <canvas id="summary-chart-record"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>